import { render, staticRenderFns } from "./ListaRecepciones.vue?vue&type=template&id=02a55e77&"
import script from "./ListaRecepciones.vue?vue&type=script&lang=js&"
export * from "./ListaRecepciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports